<template>
  <div>
    <loading
      :active="false"
      :can-cancel="false"
      :is-full-page="false"
    />
    <div
      style="text-align:left"
    >

      <h4> <input-color-picker
        v-model="colorPicker"
        @change="colorPickerChange" 
      /> {{ item }}</h4>
      
    </div>
  </div>
</template>
<script>
import { BButton } from 'bootstrap-vue'
import InputColorPicker from 'vue-native-color-picker'
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import store from '@/store/index'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import HistogramSlider from './HistogramSlider.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import { ToggleButton } from 'vue-js-toggle-button'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    InputColorPicker,
    HistogramSlider,
    VueRangeSlider,
    BButton,
    Loading,
    ToggleButton
  },
  props: {
   
    item: {
      required: true,
      type: [Object, String],
      default: '',
    },
   
  },
  data() {
    return {
      isLoadingInfo: true,
      change_percent: false,
      newcolor: this.color,
      colorPicker: this.color,
      histogram_x: [],
      histogram_y: [],
      histogram: {},
      update: 0,
      img: '',
      isLoading: false,
      newbrightness: this.brightness,
      newcontrast: this.contrast,
      newsaturation: this.saturation,
      bgStyle: {
        backgroundColor: '#fff',
        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
      },
      tooltipStyle: {
        backgroundColor: '#666',
        borderColor: '#666',
      },
      processStyle: {
        backgroundColor: '#999',
      },
    }
  },

  computed: {
    minsat() {
      return (this.histogram_x.length === 0) ? 0 : Math.ceil((this.histogram_x[0] + Number.EPSILON) * 10) / 10
    },
    maxsat() {
      return (this.histogram_x.length === 0) ? 100 : Math.floor((this.histogram_x.at(-1) + Number.EPSILON) * 10) / 10
    },
  },
  watch: {
    change_percent(value){
      if (!this.isLoading)
        this.refreshMarker()
 
    
     
    },
    newcolor() {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
      if (!this.isLoading)
        this.refreshMarker()
    },
    newbrightness() {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
      if (!this.isLoading)
        this.refreshMarker()
    },
    newcontrast() {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
      if (!this.isLoading)
        this.refreshMarker()
    },
    newsaturation(to, from) {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
      if (!this.isLoading && ( from[0] !== 0 &&  from[1] !== 100 ))
        this.refreshMarker()
    },
  },
  mounted() {
    
  },
  methods: {
    
  
  },
}
</script>
<style>
.icp__input {
    height: 20px!important;
    width: 20px!important;
    margin-right:10px;
}
.swal2-actions button{
 margin: 0 10px;
}
.vue-range-slider.slider-component {
  margin-left:0px!important;
}
.sat_slider{
    margin-top: -30px!important;
    margin-bottom: 20px!important;
}
/* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
    background-color: dodgerblue !important;
} */

</style>
<style scoped>

h4{
    display: flex;
    align-items: flex-start;
}
#content{
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: space-between;
}
#picture{
    width: 55%;
    display: flex;
    align-items: center;
}
#picture img{
    max-width: 90%;
    max-height: 365px
}
#histograms{
    width: 40%;
}

</style>
